import Vue from 'vue';
import injector from 'vue-inject';
import router from '../router';
Vue.use(injector);

require('./api');
require('./popup');
require('./user');

let api     = injector.get('api'),
    popup   = injector.get('popup'),
    user    = injector.get('user');

class Packet {
    /**
     * Create recipient
     * @param value
     */
    create (value) {
        this.value = value;
    }

    /**
     * Buy packet
     */
    buy (method, code, upgrade) {
        let params = {};

        return new Promise((resolve, reject) => {
            if (method === 'futurenetAccount') {
                params = {
                    package: this.value
                };

                if (upgrade) {
                    params['upgradePackageId'] = upgrade;
                }

                Vue.http.post(api.package.buy, params).then(response => {
                    user.reloadData(response.data).then(() => {
                        popup.show('The package has been bought correctly.');
                        router.push({ name: 'Dashboard' });
                        resolve();
                    })
                }, error => {
                    reject(error);
                });
            }
            else if (method === 'transferMoney') {
                params = {
                    product: this.value
                };

                if (upgrade) {
                    params['upgradePackageId'] = upgrade;
                }
                Vue.http.post(api.futurepay.buy, params).then(response => {
                    window.open(response.data.data.url, '_self');
                    resolve();
                }, error => {
                    reject(error);
                });
            } else if (method === 'code') {
                params = {
                    package: this.value,
                    code: code
                };

                if (upgrade) {
                    params['upgradePackageId'] = upgrade;
                }

                Vue.http.post(api.futurepay.buyWithCode, params).then(response => {
                    user.reloadData(response.data).then(() => {
                        popup.show('The package has been bought correctly.');
                        router.push({ name: 'Dashboard' });
                        resolve();
                    })
                }, error => {
                    reject(error);
                })
            } else if (method === 'bitcoin') {
                params = {
                    product: this.value
                };

                if (upgrade) {
                    params['upgradePackageId'] = upgrade;
                }

                Vue.http.post(api.microWallet.buyPackage, params).then(response => {
                    user.reloadData(response.data).then(() => {
                        popup.show('The package has been bought correctly.');
                        router.push({ name: 'Dashboard' });
                        resolve();
                    })
                }, error => {
                    reject(error);
                });
            }
        })
    }
}
injector.service('packet', Packet);



// WEBPACK FOOTER //
// ./src/services/packet.js